// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../images/sidebar-icon/my-homes-logo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../images/sidebar-icon/arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../images//sidebar-icon/arrow.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header */

.main-nav--bg {
  background: #fafafa !important;
}

.search-wrapper h3 {
  color: var(--Black, #010404);
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 2px;
}
.btn_export {
  display: flex;
  max-width: 105px;
  min-height: 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  border: 1px solid var(--Primary, #163873);
  background: var(--Base, #fafafa);
  color: var(--Primary, #163873);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.notification-wrapper .gray-circle-btn {
  background-color: #fafafa;
}
.main-nav .user-profile {
  border-radius: unset;
  justify-content: center;
  overflow: hidden;
  background-color: unset;
}

/* sidebar  */
.sidebar-hidden {
  position: sticky;
  top: 0;
  height: 100%;
  background: #163873 !important;
  width: 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px 15px 37px 20px;
  transition: 0.5s all;
  min-height: 100vh;
}

.sidebar {
  position: sticky;
  top: 0;
  height: 100%;
  background: #163873 !important;
  width: 350px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px 15px 37px 20px;
  transition: 0.5s all;
  min-height: 100vh;
}
.sidebar a:focus {
  outline: 0;
}
.sidebar-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.sidebar-body {
  padding-top: 20px;
}
.sidebar-body-menu {
  padding: 0;
}
.sidebar-body-menu a,
.sidebar-user {
  align-items: center;
  flex-wrap: wrap;
}
.sidebar-body-menu a {
  position: relative;
  color: var(--White, #fff);
  text-align: right;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.sidebar-body-menu a::after {
  position: absolute;
  content: "";
  height: 22px;
  width: 3px;
  right: -11px;
  border-radius: 10px;
  background-color: #fff;
  opacity: 0;
  transition: 0.3s all;
}

.sidebar-user {
  border-radius: 10px;
  padding: 5px;
  background-color: rgba(255, 255, 255, 0.1);
}
.sidebar-body-menu a,
.sidebar-user,
.sidebar-user-img,
.sidebar-user-info {
  display: flex;
  gap: 10px;
}
.sidebar-user-img {
  justify-content: center;
  align-items: flex-end;
  margin-right: 8px;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  overflow: hidden;
  background-color: #fff;
}
.sidebar-user-info {
  flex-direction: column;
}
.sidebar-user__title {
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.75px;
  color: #fff;
}
.sidebar-user__subtitle {
  font-weight: 500;
  font-size: 10px;
  line-height: 1.5;
  letter-spacing: 0.86px;
  color: rgba(255, 255, 255, 0.5);
}
.sidebar .sidebar-body-menu li {
  position: relative;
  margin-bottom: 20px;
}
.sidebar .sidebar-body-menu a {
  position: relative;
  padding: 10px 15px;
}

.sidebar .sidebar-body-menu .active {
  padding: 10px 0px;
}
.sidebar-start .sidebar-head {
  border-bottom: none;
  padding-top: 20px;
}
.sidebar-head .logo {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  min-width: 200px;
  height: 44px;
}
.sidebar-head .menu-toggle {
  width: 30px;
  height: 30px;
  cursor: pointer;
}

.sidebar-body-menu a.active svg path,
.sidebar-body-menu a:hover svg path {
  fill: #163873;
}
.sidebar-body-menu a.active::after,
.sidebar-body-menu a:hover::after {
  opacity: 1;
  border-radius: 12px;
  background: #fff;
  color: var(--Primary, #163873);
  display: none;
}
ul.cat-sub-menu {
  border-radius: 0px 0px 12px 12px;
  opacity: 0.75;
  background: #c5cddc;
  padding: 0;
}
.cat-sub-menu.visible {
  padding: 20px 30px;
  position: relative;
  height: auto;
}

.cat-sub-menu.visible::before {
  content: "";
  position: absolute;
  left: 12px;
  top: 0;
  border: 1px solid #a4b4b2;
  height: calc(100% - 40px);
  width: auto;
}

ul.cat-sub-menu.visible li {
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.5);
  position: relative;
}
ul.cat-sub-menu.visible li::before {
  content: "";
  position: absolute;
  left: -18px;
  top: 18px;
  width: calc(100% - 91%);
  height: auto;
  border: 1px solid #a4b4b2;
}

.logo-text,
.logo-wrapper {
  display: flex;
}
.logo-wrapper {
  align-items: center;
  flex-wrap: wrap;
}
.logo-text {
  flex-direction: column;
  color: #fff;
}
.logo-subtitle,
.logo-title {
  font-size: 21px;
  font-weight: 700;
  line-height: 1.4;
  letter-spacing: 0.86px;
}
.logo-subtitle {
  font-size: 12px;
  font-weight: 500;
  line-height: 2.42;
}
.msg-counter,
.system-menu__title {
  font-weight: 500;
  line-height: 1.25;
  letter-spacing: 0.75px;
}
.msg-counter {
  position: absolute;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  background-color: #f26464;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px !important;
  color: #fff;
}
.system-menu__title {
  display: inline-block;
  margin-top: 13px;
  margin-bottom: 2px;
  text-transform: uppercase;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
}
.cat-sub-menu {
  padding-left: 34px;
  height: 0;
}

.cat-sub-menu.visible a {
  opacity: 1;
  visibility: visible;
  color: var(--Black, #010404);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.cat-sub-menu a {
  opacity: 0;
  visibility: hidden;
}
.category__btn .icon {
  transition: 0.3s;
}
/* add some css make for responsive for header */
.main-nav {
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%; 
}
.main-nav a:focus {
  outline: 0;
}

.main-nav-end {
  display: flex;
  align-items: center;
}
.main-nav-end > * {
  margin-right: 15px;
}
.footer-end li:last-child,
.main-btns-wrapper button:last-child,
.main-nav-end > :last-child,
.sort-bar .select-wrapper:last-child .select {
  margin-right: 0;
}
.main-nav .notification,
.main-nav .notification-wrapper {
  position: relative;
}
.main-nav .notification::after {
  display: none;
  content: "";
  position: absolute;
  right: 0;
  top: 0;
  border-radius: 50%;
  height: 9px;
  width: 9px;
  border: 1px solid #fff;
  background-color: #f26464;
}
.main-nav .notification.active::after {
  display: initial;
}
.main-nav .notification-dropdown {
  right: 0;
  width: 236px;
  padding: 10px;
}
.main-nav .notification-dropdown-text {
  display: flex;
  flex-direction: column;
  width: 167px;
}
.main-nav .notification-dropdown__title {
  font-weight: 500;
  font-size: 14px;
  line-height: 1.22;
  color: #171717;
  margin-bottom: 5px;
}
.main-nav .notification-dropdown__subtitle {
  font-size: 10px;
  line-height: 1.2;
  color: #767676;
  white-space: break-spaces;
}
.main-nav .notification-dropdown-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.main-nav .notification-dropdown-icon.info {
  background-color: rgba(88, 135, 255, 0.1);
  color: #5887ff;
}
.main-nav .notification-dropdown-icon.danger {
  background-color: rgba(242, 100, 100, 0.1);
  color: #f26464;
}
.main-nav .notification-dropdown a {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-bottom: 10px;
  padding-top: 15px;
}
.main-nav .notification-dropdown a.link-to-page {
  padding-top: 17px;
  justify-content: center;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: #5887ff;
}
.main-nav .nav-user-wrapper,
.search-wrapper {
  position: relative;
}
.main-nav .nav-user-wrapper .users-item-dropdown {
  width: 171px;
  right: 0;
}
.main-nav .nav-user-wrapper .users-item-dropdown svg {
  margin-right: 13px;
}
.main-nav .nav-user-img,
.main-nav .nav-user-img picture,
.main-nav .nav-user-wrapper .users-item-dropdown a {
  display: flex;
  align-items: center;
}
.main-nav .nav-user-wrapper .users-item-dropdown a.danger {
  color: #f26464;
}
.main-nav .nav-user-img {
  border-radius: 50%;
  justify-content: center;
  overflow: hidden;
  width: 40px;
  height: 40px;
  background-color: #f5efff;
}
.main-nav .nav-user-img picture {
  align-items: flex-end;
}
.search-wrapper input {
  width: 271px;
  border-radius: 6px;
  background-color: #eff0f6;
  padding: 3px 8px 3px 42px;
  height: 40px;
  border-width: 0;
}
.search-wrapper input::placeholder {
  background-color: #eff0f6;
  font-size: 14px;
  line-height: 2.43;
  color: #d6d7e3;
  transition: 0.3s all;
}
.dropdown-toggle::after {
  display: none !important;
}

.arrow-down {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
}

.sidebar-body-menu a:hover .transparent-btn .arrow-down {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) !important;
}

.accordion-button {
  color: #163873 !important;
  font-weight: 700;
}

button.accordion-button.collapsed {
  padding: 0px !important;
  background-color: none !important;
  color: #fff;
}

button.accordion-button {
  padding: 0px;
  background: none !important;
  border: none !important;
}

.accordion-button:focus {
  border: none !important;
  box-shadow: none !important;
}

.dropdown__menu .accordion-body {
  padding: 0px 35px !important;
  position: relative;
}

.dropdown__menu .accordion-collapse.collapse.show {
  background: #cbcbcb;
  padding-bottom: 20px;
}
.dropdown__menu .accordion-header {
  padding: 10px;
  background: #fff;
  border-radius: 10px 10px 0px 0px;
}
.dropdown__menu .accordion-body::before {
  content: "";
  position: absolute;
  left: 15px;
  top: 0;
  width: 2px;
  height: calc(100% - 20px);
  background-color: #a4b4b2;
}

/* New css sidebar */

.side__text {
  max-width: 500px;
  margin: auto;
}

.side__text .list-group .collapsed {
  padding: 0;
  line-height: 30px;
  margin-bottom: 15px;
  transition: all 0.5s;
  background: none;
  border: none;
  border-radius: 10px;
}

.side__text .list-group .list-group-item {
  border-radius: 10px 10px 0px 0px;
  padding: 0;
  line-height: 30px;
  margin-bottom: 15px;
  transition: all 0.5s;
  background: none;
  border: none;
}

.side__text .list-group .collapsed .menu_heading {
  border-radius: 10px !important;
}

.menu_heading {
  padding: 10px;
  cursor: pointer;
  border-radius: 10px 10px 0px 0px;
}

.menu_heading .dropdown-toggle :active {
  background: white;
}

/* add some css for manage sidebar */
.hidden .accordion_sub_menu {
  display: none;
}
.accordion_sub_menu{
  background-color: #e5e5e5;
  padding: 10px;
  border-radius: 0px 0px 10px 10px;
}
.accordion_sub_menu .card-body {
  background-color: transparent;
  border: none;
  position: relative;
  padding: 0 1.25rem;
}

.accordion_sub_menu .card-body::before {
  content: "";
  position: absolute;
  left: 0px;
  top: -10px;
  width: 2px;
  height: 100%;
  background: #d3d3d3;
}

.accordion_sub_menu .card-body ul {
  list-style: none;
  padding: 0;
}

.accordion_sub_menu .card-body ul li {
  padding: 5px 10px;
  border-radius: 5px;
  background-color: #f3f3f3;
  margin-bottom: 15px;
  position: relative;
}

.accordion_sub_menu .card-body ul li::before {
  content: "";
  position: absolute;
  left: -20px;
  top: 20px;
  width: 20px;
  height: 2px;
  background: #d3d3d3;
}

.accordion_sub_menu .card-body ul li a {
  font-size: 18px;
  color: #282828;
  font-weight: 400;
  text-decoration: none;
  transition: all 0.5s;
}
.list-group-item .menu_heading {
  color: #fff !important;
}

.list-group-item .menu_heading.active {
  background: #ffff;
  color: #163873 !important;
  font-weight: 700 !important;
}
.list-group-item .menu_heading:hover {
  background: #ffff !important;
  color: #163873 !important;
  font-weight: 700;
}

.list-group-item .menu_heading .active {
  color: #163873 !important;
}
.list-group-item .menu_heading :hover {
  color: #163873 !important;
}
.list-group-item:hover.list-group-item svg path {
  fill: #163873;
}
.list-group-item .active svg path {
  fill: #163873;
}
.list-group-item .menu_heading a {
  color: #ffff !important;
}

/*small and full width css*/
.hidden .sidebar-head .logo {
  display: none;
}
.hidden .sidebar-head {
  justify-content: center;
}

.hidden {
  width: 100px;
}

.hidden .span__text {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/customerpenal/styles/customer-sidebar.css"],"names":[],"mappings":"AAAA,WAAW;;AAEX;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yCAAyC;EACzC,gCAAgC;EAChC,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EAGpB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,aAAa;AACb;EAEE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EAGZ,aAAa;EAIb,sBAAsB;EAGtB,8BAA8B;EAC9B,4BAA4B;EAG5B,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EAEE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EAGZ,aAAa;EAIb,sBAAsB;EAGtB,8BAA8B;EAC9B,4BAA4B;EAG5B,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EAGE,aAAa;EAGb,8BAA8B;EAG9B,mBAAmB;EAEnB,eAAe;EACf,oBAAoB;EACpB,iDAAiD;AACnD;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;;EAIE,mBAAmB;EAEnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,UAAU;EAGV,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,0CAA0C;AAC5C;AACA;;;;EAME,aAAa;EACb,SAAS;AACX;AACA;EAGE,uBAAuB;EAGvB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EAIE,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,yDAAuE;EACvE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;AACA;;EAEE,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,aAAa;AACf;AACA;EACE,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;;EAIE,aAAa;AACf;AACA;EAGE,mBAAmB;EAEnB,eAAe;AACjB;AACA;EAIE,sBAAsB;EACtB,WAAW;AACb;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAGlB,aAAa;EAGb,uBAAuB;EAGvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,QAAQ;EACR,QAAQ;EAGR,2BAA2B;EAC3B,0BAA0B;EAC1B,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EAGE,gBAAgB;AAClB;AACA,gDAAgD;AAChD;EACE,iBAAiB;EACjB,oBAAoB;EAGpB,aAAa;EAGb,mBAAmB;EAGnB,8BAA8B;EAE9B,eAAe;EACf,WAAW;AACb;AACA;EACE,UAAU;AACZ;;AAEA;EAGE,aAAa;EAGb,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;;;;EAIE,eAAe;AACjB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,YAAY;EACZ,aAAa;AACf;AACA;EAGE,aAAa;EAIb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;AACA;EAGE,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,yCAAyC;EACzC,cAAc;AAChB;AACA;EACE,0CAA0C;EAC1C,cAAc;AAChB;AACA;EAGE,aAAa;EAGb,uBAAuB;EAGvB,8BAA8B;EAE9B,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EAGjB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,QAAQ;AACV;AACA;EACE,kBAAkB;AACpB;AACA;;;EAKE,aAAa;EAGb,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAGlB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;AACA;EAGE,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;AA0BA;EACE,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,cAAc;EAGd,oBAAoB;AACtB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oEAA0E;AAC5E;;AAEA;EACE,oEAA2E;AAC7E;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,UAAU;EACV,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,oBAAoB;;AAEpB;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA,oCAAoC;AACpC;EACE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,gCAAgC;AAClC;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,uBAAuB;AACzB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;AACf;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf","sourcesContent":["/* Header */\n\n.main-nav--bg {\n  background: #fafafa !important;\n}\n\n.search-wrapper h3 {\n  color: var(--Black, #010404);\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  letter-spacing: 2px;\n}\n.btn_export {\n  display: flex;\n  max-width: 105px;\n  min-height: 40px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 8px;\n  border: 1px solid var(--Primary, #163873);\n  background: var(--Base, #fafafa);\n  color: var(--Primary, #163873);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.notification-wrapper .gray-circle-btn {\n  background-color: #fafafa;\n}\n.main-nav .user-profile {\n  border-radius: unset;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  overflow: hidden;\n  background-color: unset;\n}\n\n/* sidebar  */\n.sidebar-hidden {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  height: 100%;\n  background: #163873 !important;\n  width: 100px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  padding: 20px 15px 37px 20px;\n  -webkit-transition: 0.5s all;\n  -o-transition: 0.5s all;\n  transition: 0.5s all;\n  min-height: 100vh;\n}\n\n.sidebar {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  height: 100%;\n  background: #163873 !important;\n  width: 350px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  padding: 20px 15px 37px 20px;\n  -webkit-transition: 0.5s all;\n  -o-transition: 0.5s all;\n  transition: 0.5s all;\n  min-height: 100vh;\n}\n.sidebar a:focus {\n  outline: 0;\n}\n.sidebar-head {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  padding-bottom: 20px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n.sidebar-body {\n  padding-top: 20px;\n}\n.sidebar-body-menu {\n  padding: 0;\n}\n.sidebar-body-menu a,\n.sidebar-user {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n.sidebar-body-menu a {\n  position: relative;\n  color: var(--White, #fff);\n  text-align: right;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.sidebar-body-menu a::after {\n  position: absolute;\n  content: \"\";\n  height: 22px;\n  width: 3px;\n  right: -11px;\n  border-radius: 10px;\n  background-color: #fff;\n  opacity: 0;\n  -webkit-transition: 0.3s all;\n  -o-transition: 0.3s all;\n  transition: 0.3s all;\n}\n\n.sidebar-user {\n  border-radius: 10px;\n  padding: 5px;\n  background-color: rgba(255, 255, 255, 0.1);\n}\n.sidebar-body-menu a,\n.sidebar-user,\n.sidebar-user-img,\n.sidebar-user-info {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 10px;\n}\n.sidebar-user-img {\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: end;\n  -ms-flex-align: end;\n  align-items: flex-end;\n  margin-right: 8px;\n  border-radius: 50%;\n  width: 48px;\n  height: 48px;\n  overflow: hidden;\n  background-color: #fff;\n}\n.sidebar-user-info {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n.sidebar-user__title {\n  font-weight: 600;\n  font-size: 14px;\n  letter-spacing: 0.75px;\n  color: #fff;\n}\n.sidebar-user__subtitle {\n  font-weight: 500;\n  font-size: 10px;\n  line-height: 1.5;\n  letter-spacing: 0.86px;\n  color: rgba(255, 255, 255, 0.5);\n}\n.sidebar .sidebar-body-menu li {\n  position: relative;\n  margin-bottom: 20px;\n}\n.sidebar .sidebar-body-menu a {\n  position: relative;\n  padding: 10px 15px;\n}\n\n.sidebar .sidebar-body-menu .active {\n  padding: 10px 0px;\n}\n.sidebar-start .sidebar-head {\n  border-bottom: none;\n  padding-top: 20px;\n}\n.sidebar-head .logo {\n  background-image: url(\"../../../images/sidebar-icon/my-homes-logo.png\");\n  min-width: 200px;\n  height: 44px;\n}\n.sidebar-head .menu-toggle {\n  width: 30px;\n  height: 30px;\n  cursor: pointer;\n}\n\n.sidebar-body-menu a.active svg path,\n.sidebar-body-menu a:hover svg path {\n  fill: #163873;\n}\n.sidebar-body-menu a.active::after,\n.sidebar-body-menu a:hover::after {\n  opacity: 1;\n  border-radius: 12px;\n  background: #fff;\n  color: var(--Primary, #163873);\n  display: none;\n}\nul.cat-sub-menu {\n  border-radius: 0px 0px 12px 12px;\n  opacity: 0.75;\n  background: #c5cddc;\n  padding: 0;\n}\n.cat-sub-menu.visible {\n  padding: 20px 30px;\n  position: relative;\n  height: auto;\n}\n\n.cat-sub-menu.visible::before {\n  content: \"\";\n  position: absolute;\n  left: 12px;\n  top: 0;\n  border: 1px solid #a4b4b2;\n  height: calc(100% - 40px);\n  width: auto;\n}\n\nul.cat-sub-menu.visible li {\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.5);\n  position: relative;\n}\nul.cat-sub-menu.visible li::before {\n  content: \"\";\n  position: absolute;\n  left: -18px;\n  top: 18px;\n  width: calc(100% - 91%);\n  height: auto;\n  border: 1px solid #a4b4b2;\n}\n\n.logo-text,\n.logo-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.logo-wrapper {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n.logo-text {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  color: #fff;\n}\n.logo-subtitle,\n.logo-title {\n  font-size: 21px;\n  font-weight: 700;\n  line-height: 1.4;\n  letter-spacing: 0.86px;\n}\n.logo-subtitle {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 2.42;\n}\n.msg-counter,\n.system-menu__title {\n  font-weight: 500;\n  line-height: 1.25;\n  letter-spacing: 0.75px;\n}\n.msg-counter {\n  position: absolute;\n  border-radius: 50%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  width: 20px;\n  height: 20px;\n  background-color: #f26464;\n  right: 0;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n  font-size: 12px !important;\n  color: #fff;\n}\n.system-menu__title {\n  display: inline-block;\n  margin-top: 13px;\n  margin-bottom: 2px;\n  text-transform: uppercase;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.5);\n}\n.cat-sub-menu {\n  padding-left: 34px;\n  height: 0;\n}\n\n.cat-sub-menu.visible a {\n  opacity: 1;\n  visibility: visible;\n  color: var(--Black, #010404);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.cat-sub-menu a {\n  opacity: 0;\n  visibility: hidden;\n}\n.category__btn .icon {\n  -webkit-transition: 0.3s;\n  -o-transition: 0.3s;\n  transition: 0.3s;\n}\n/* add some css make for responsive for header */\n.main-nav {\n  padding-top: 20px;\n  padding-bottom: 20px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  width: 100%; \n}\n.main-nav a:focus {\n  outline: 0;\n}\n\n.main-nav-end {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.main-nav-end > * {\n  margin-right: 15px;\n}\n.footer-end li:last-child,\n.main-btns-wrapper button:last-child,\n.main-nav-end > :last-child,\n.sort-bar .select-wrapper:last-child .select {\n  margin-right: 0;\n}\n.main-nav .notification,\n.main-nav .notification-wrapper {\n  position: relative;\n}\n.main-nav .notification::after {\n  display: none;\n  content: \"\";\n  position: absolute;\n  right: 0;\n  top: 0;\n  border-radius: 50%;\n  height: 9px;\n  width: 9px;\n  border: 1px solid #fff;\n  background-color: #f26464;\n}\n.main-nav .notification.active::after {\n  display: initial;\n}\n.main-nav .notification-dropdown {\n  right: 0;\n  width: 236px;\n  padding: 10px;\n}\n.main-nav .notification-dropdown-text {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  width: 167px;\n}\n.main-nav .notification-dropdown__title {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 1.22;\n  color: #171717;\n  margin-bottom: 5px;\n}\n.main-nav .notification-dropdown__subtitle {\n  font-size: 10px;\n  line-height: 1.2;\n  color: #767676;\n  white-space: break-spaces;\n}\n.main-nav .notification-dropdown-icon {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n}\n.main-nav .notification-dropdown-icon.info {\n  background-color: rgba(88, 135, 255, 0.1);\n  color: #5887ff;\n}\n.main-nav .notification-dropdown-icon.danger {\n  background-color: rgba(242, 100, 100, 0.1);\n  color: #f26464;\n}\n.main-nav .notification-dropdown a {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  padding-bottom: 10px;\n  padding-top: 15px;\n}\n.main-nav .notification-dropdown a.link-to-page {\n  padding-top: 17px;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 15px;\n  color: #5887ff;\n}\n.main-nav .nav-user-wrapper,\n.search-wrapper {\n  position: relative;\n}\n.main-nav .nav-user-wrapper .users-item-dropdown {\n  width: 171px;\n  right: 0;\n}\n.main-nav .nav-user-wrapper .users-item-dropdown svg {\n  margin-right: 13px;\n}\n.main-nav .nav-user-img,\n.main-nav .nav-user-img picture,\n.main-nav .nav-user-wrapper .users-item-dropdown a {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.main-nav .nav-user-wrapper .users-item-dropdown a.danger {\n  color: #f26464;\n}\n.main-nav .nav-user-img {\n  border-radius: 50%;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  overflow: hidden;\n  width: 40px;\n  height: 40px;\n  background-color: #f5efff;\n}\n.main-nav .nav-user-img picture {\n  -webkit-box-align: end;\n  -ms-flex-align: end;\n  align-items: flex-end;\n}\n.search-wrapper input {\n  width: 271px;\n  border-radius: 6px;\n  background-color: #eff0f6;\n  padding: 3px 8px 3px 42px;\n  height: 40px;\n  border-width: 0;\n}\n.search-wrapper input::-webkit-input-placeholder {\n  background-color: #eff0f6;\n  font-size: 14px;\n  line-height: 2.43;\n  color: #d6d7e3;\n  -webkit-transition: 0.3s all;\n  transition: 0.3s all;\n}\n.search-wrapper input::-moz-placeholder {\n  background-color: #eff0f6;\n  font-size: 14px;\n  line-height: 2.43;\n  color: #d6d7e3;\n  -moz-transition: 0.3s all;\n  transition: 0.3s all;\n}\n.search-wrapper input:-ms-input-placeholder,\n.search-wrapper input::-ms-input-placeholder {\n  background-color: #eff0f6;\n  font-size: 14px;\n  line-height: 2.43;\n  color: #d6d7e3;\n  -ms-transition: 0.3s all;\n  transition: 0.3s all;\n}\n.search-wrapper input::placeholder {\n  background-color: #eff0f6;\n  font-size: 14px;\n  line-height: 2.43;\n  color: #d6d7e3;\n  -webkit-transition: 0.3s all;\n  -o-transition: 0.3s all;\n  transition: 0.3s all;\n}\n.dropdown-toggle::after {\n  display: none !important;\n}\n\n.arrow-down {\n  background-image: url(\"../../../images/sidebar-icon/arrow.svg\") !important;\n}\n\n.sidebar-body-menu a:hover .transparent-btn .arrow-down {\n  background-image: url(\"../../../images//sidebar-icon/arrow.svg\") !important;\n}\n\n.accordion-button {\n  color: #163873 !important;\n  font-weight: 700;\n}\n\nbutton.accordion-button.collapsed {\n  padding: 0px !important;\n  background-color: none !important;\n  color: #fff;\n}\n\nbutton.accordion-button {\n  padding: 0px;\n  background: none !important;\n  border: none !important;\n}\n\n.accordion-button:focus {\n  border: none !important;\n  box-shadow: none !important;\n}\n\n.dropdown__menu .accordion-body {\n  padding: 0px 35px !important;\n  position: relative;\n}\n\n.dropdown__menu .accordion-collapse.collapse.show {\n  background: #cbcbcb;\n  padding-bottom: 20px;\n}\n.dropdown__menu .accordion-header {\n  padding: 10px;\n  background: #fff;\n  border-radius: 10px 10px 0px 0px;\n}\n.dropdown__menu .accordion-body::before {\n  content: \"\";\n  position: absolute;\n  left: 15px;\n  top: 0;\n  width: 2px;\n  height: calc(100% - 20px);\n  background-color: #a4b4b2;\n}\n\n/* New css sidebar */\n\n.side__text {\n  max-width: 500px;\n  margin: auto;\n}\n\n.side__text .list-group .collapsed {\n  padding: 0;\n  line-height: 30px;\n  margin-bottom: 15px;\n  transition: all 0.5s;\n  background: none;\n  border: none;\n  border-radius: 10px;\n}\n\n.side__text .list-group .list-group-item {\n  border-radius: 10px 10px 0px 0px;\n  padding: 0;\n  line-height: 30px;\n  margin-bottom: 15px;\n  transition: all 0.5s;\n  background: none;\n  border: none;\n}\n\n.side__text .list-group .collapsed .menu_heading {\n  border-radius: 10px !important;\n}\n\n.menu_heading {\n  padding: 10px;\n  cursor: pointer;\n  border-radius: 10px 10px 0px 0px;\n}\n\n.menu_heading .dropdown-toggle :active {\n  background: white;\n}\n\n/* add some css for manage sidebar */\n.hidden .accordion_sub_menu {\n  display: none;\n}\n.accordion_sub_menu{\n  background-color: #e5e5e5;\n  padding: 10px;\n  border-radius: 0px 0px 10px 10px;\n}\n.accordion_sub_menu .card-body {\n  background-color: transparent;\n  border: none;\n  position: relative;\n  padding: 0 1.25rem;\n}\n\n.accordion_sub_menu .card-body::before {\n  content: \"\";\n  position: absolute;\n  left: 0px;\n  top: -10px;\n  width: 2px;\n  height: 100%;\n  background: #d3d3d3;\n}\n\n.accordion_sub_menu .card-body ul {\n  list-style: none;\n  padding: 0;\n}\n\n.accordion_sub_menu .card-body ul li {\n  padding: 5px 10px;\n  border-radius: 5px;\n  background-color: #f3f3f3;\n  margin-bottom: 15px;\n  position: relative;\n}\n\n.accordion_sub_menu .card-body ul li::before {\n  content: \"\";\n  position: absolute;\n  left: -20px;\n  top: 20px;\n  width: 20px;\n  height: 2px;\n  background: #d3d3d3;\n}\n\n.accordion_sub_menu .card-body ul li a {\n  font-size: 18px;\n  color: #282828;\n  font-weight: 400;\n  text-decoration: none;\n  transition: all 0.5s;\n}\n.list-group-item .menu_heading {\n  color: #fff !important;\n}\n\n.list-group-item .menu_heading.active {\n  background: #ffff;\n  color: #163873 !important;\n  font-weight: 700 !important;\n}\n.list-group-item .menu_heading:hover {\n  background: #ffff !important;\n  color: #163873 !important;\n  font-weight: 700;\n}\n\n.list-group-item .menu_heading .active {\n  color: #163873 !important;\n}\n.list-group-item .menu_heading :hover {\n  color: #163873 !important;\n}\n.list-group-item:hover.list-group-item svg path {\n  fill: #163873;\n}\n.list-group-item .active svg path {\n  fill: #163873;\n}\n.list-group-item .menu_heading a {\n  color: #ffff !important;\n}\n\n/*small and full width css*/\n.hidden .sidebar-head .logo {\n  display: none;\n}\n.hidden .sidebar-head {\n  justify-content: center;\n}\n\n.hidden {\n  width: 100px;\n}\n\n.hidden .span__text {\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
